import { Chakra } from "@airhelp/react-ui-components";
import Grid from "modules/common/components/Grid";
import BestAirlinesByCountry from "./BestAirlinesByCountry";
import BestAirlinesByRegion from "./BestAirlinesByRegion";
import type { BestAirlinesProps } from "./BestAirlines.d";

const { Box, SimpleGrid } = Chakra;

const BestAirlines = ({ airlinesScoresByCountry }: BestAirlinesProps) => (
  <Box bg="greyscale.300" pb={{ base: 0, lg: 28 }}>
    <Grid mb={0} px={{ base: 0, lg: 4 }}>
      <Box gridColumn={{ base: "span 1", md: "span 12" }}>
        <SimpleGrid columns={{ base: 1, lg: 2 }} spacing={{ base: 0, lg: 8 }}>
          <BestAirlinesByCountry airlinesScoresByCountry={airlinesScoresByCountry} />
          <BestAirlinesByRegion />
        </SimpleGrid>
      </Box>
    </Grid>
  </Box>
);

export default BestAirlines;
